import { UseQueryResult } from '@tanstack/react-query';
import { useSession } from '../SessionProvider';
import { getSelectables, Selectable } from './getSelectables';
import { useTrackedQuery as useQuery } from '@ais-ui/performance-tracking';

export const useGetSelectables = (
  thing: string
): UseQueryResult<Selectable[]> => {
  const { olSession } = useSession();

  return useQuery(['getSelectables', thing], async () => {
    const selectables = await getSelectables(olSession, thing);

    // Check if selectables is a string that looks like an array
    if (typeof selectables === 'string') {
      try {
        // Try to parse the string into an array
        return JSON.parse(selectables);
      } catch (error) {
        console.error('Error parsing selectables:', error);
      }
    }

    // If selectables is not a string that looks like an array, return it as is
    return selectables;
  });
};
